// Client-side "Add to calendar" helpers (Google Calendar link + downloadable .ics).
// Events are UK-local; we emit floating local times so they land at the venue's clock time.

function pad(n) { return String(n).padStart(2, "0"); }

// "YYYY-MM-DD" + "HH:MM" -> "YYYYMMDDTHHMMSS" (floating local, no timezone marker)
function toStamp(dateStr, timeStr) {
  const d = (dateStr || "").replaceAll("-", "");
  if (!timeStr) return d; // all-day marker (date only)
  const [h = "00", m = "00"] = timeStr.split(":");
  return `${d}T${pad(h)}${pad(m)}00`;
}

// Add one hour to a "HH:MM" string (used when only a start time is given).
function addHour(timeStr) {
  const [h = "0", m = "0"] = timeStr.split(":");
  const nh = (parseInt(h, 10) + 1) % 24;
  return `${pad(nh)}:${pad(m)}`;
}

function nextDay(dateStr) {
  const dt = new Date(dateStr + "T00:00:00");
  dt.setDate(dt.getDate() + 1);
  return `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
}

export function calendarEvent(o) {
  const title = o.title || "Event";
  const location = [o.venue_name, o.location].filter(Boolean).join(", ");
  const bits = [];
  if (o.business_name) bits.push(`Hosted by ${o.business_name}`);
  if (o.what_creators_receive) bits.push(`You'll receive: ${o.what_creators_receive}`);
  if (o.content_expectations) bits.push(`Content: ${o.content_expectations}`);
  if (o.description) bits.push(o.description);
  bits.push("Added from Nearfluence");
  return { title, location, details: bits.join("\n\n"), date: o.event_date, start: o.start_time || "", end: o.end_time || "" };
}

export function googleCalendarUrl(o) {
  const e = calendarEvent(o);
  let dates;
  if (e.start) {
    const end = e.end || addHour(e.start);
    dates = `${toStamp(e.date, e.start)}/${toStamp(e.date, end)}`;
  } else {
    dates = `${toStamp(e.date, "")}/${toStamp(nextDay(e.date), "")}`; // all-day
  }
  const params = new URLSearchParams({
    action: "TEMPLATE", text: e.title, dates,
    details: e.details, location: e.location,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

function icsEscape(s) {
  return String(s || "").replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/,/g, "\\,").replace(/;/g, "\\;");
}

export function buildIcs(o) {
  const e = calendarEvent(o);
  const stamp = new Date().toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const lines = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Nearfluence//Events//EN", "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT", `UID:nf-${o.id}@nearfluence.co.uk`, `DTSTAMP:${stamp}`,
  ];
  if (e.start) {
    const end = e.end || addHour(e.start);
    lines.push(`DTSTART:${toStamp(e.date, e.start)}`, `DTEND:${toStamp(e.date, end)}`);
  } else {
    lines.push(`DTSTART;VALUE=DATE:${toStamp(e.date, "")}`, `DTEND;VALUE=DATE:${toStamp(nextDay(e.date), "")}`);
  }
  lines.push(`SUMMARY:${icsEscape(e.title)}`, `DESCRIPTION:${icsEscape(e.details)}`,
    `LOCATION:${icsEscape(e.location)}`, "END:VEVENT", "END:VCALENDAR");
  return lines.join("\r\n");
}

export function downloadIcs(o) {
  const blob = new Blob([buildIcs(o)], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(o.title || "event").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.ics`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
